import { useEffect, useState } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { formatDate, plusStringValue } from "../../../../commons/FormatValue";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import SeqRepairJobsService from "../../../../services/seqrepairjob.service";
import InformRepairJobsService from "../../../../services/informrepairjob.service";
import InformRepairItemsService from "../../../../services/informrepairitem.service";
import { flattenedArray } from "../../../../utils/ManageArray";

export default function HistoryTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [Repair, setRepair] = useState([]);
  const searchInput = [
    { name: "concern_customer_items.Cus_Code", label: "รหัสลูกค้า/สาขา" },
    {
      name: "concern_customer_items.Cus_NumBranch",
      label: "เลขที่สาขา",
      size: "2_25"
    },
    {
      name: "concern_customer_items.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      size: null
    }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "วันที่แจ้งงาน",
      selector: (row) => row?.repair_date,
      minWidth: "150px",
      format: (row) => formatDate(row?.repair_date)
    },
    {
      name: "หมายเลขแจ้งซ่อม",
      selector: (row) => row?.repair_doc_no,
      minWidth: "200px"
    },
    {
      name: "อ้างอิงวันที่แจ้ง (ลูกค้า)",
      selector: (row) => row?.ref_cus_ticket_date,
      minWidth: "230px",
      format: (row) => formatDate(row?.ref_cus_ticket_date)
    },
    {
      name: "อ้างอิง Ticket (ลูกค้า)",
      selector: (row) => row?.ref_cus_ticket_no,
      minWidth: "250px"
    },
    {
      name: "เลขที่ใบสั่งงานแจ้งซ่อม",
      selector: (row) => row?.SeqRepair?.seq_repair_no,
      minWidth: "180px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.concern_customer_items?.Cus_Code,
      minWidth: "180px"
    },
    {
      name: "เลขที่สาขา",
      selector: (row) => row?.concern_customer_items?.Cus_NumBranch,
      minWidth: "120px"
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row?.concern_customer_items?.Cus_Name,
      minWidth: "250px"
    },
    {
      name: "รายละเอียดอุปกรณ์",
      selector: (row) => row?.ItemRepair?.repair_items?.Item_Name_TH,
      minWidth: "300px"
    },
    {
      name: "อาการที่ได้รับแจ้ง",
      selector: (row) => row?.ItemRepair?.inform_des,
      minWidth: "300px"
    },
    {
      name: "ช่างปฏิบัติงาน",
      selector: (row) => row,
      minWidth: "280px",
      format: (row) =>
        plusStringValue(
          ["tech_sub_items.Employee_Name", "tech_sub_items.Employee_Surname"],
          " ",
          row
        )
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          previewButton
          state={{ preview: "history" }}
        />
      ),
      right: true,
      width: "180px"
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformRepairJobsService.getAllInformRepairJobs(),
      callback: (Jobs) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: SeqRepairJobsService.getAllSeqRepairJob(),
          callback: (Seq) =>
            getServiceRequest({
              showAlert,
              setLoading,
              serviceRequest:
                InformRepairItemsService.getAllInformRepairItems(),
              callback: (Items) => {
                const updatedJobs = Jobs.map((j) => ({
                  ...j,
                  SeqRepair: Seq.find((s) => j.id === s.inform_repair_id),
                  ItemRepair: Items.filter((i) => j.id === i.inform_repair_id)
                }));
                setRepair(flattenedArray(updatedJobs, "ItemRepair"));
              }
            })
        })
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: { text: "ค้นหาประวัติลูกค้า/สาขา", className: "text-center" }
        }}
        body={{
          element: (
            <SearchFilter
              data={Repair}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) => setSearchValue(search)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดการแจ้งซ่อม" } }}
        body={{
          element: (
            <Table
              data={Repair}
              column={columns}
              pending={loading}
              searchFilter={searchValue}
              pagination
            />
          )
        }}
      />
    </>
  );
}
